import { v4 } from "uuid";

import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { EmbeddedMod } from "@src/store/slices/experienceBuilder/types";
import { getVariationNameById } from "@src/store/slices/experienceBuilder/common/selectors/getVisualBuilderTrackingContext";
import { trackModSaved } from "@src/store/slices/experienceBuilder/common/thunks/mixPanel";
import { getCopyKey } from "@src/store/slices/experienceBuilder/common/utils/getCopyKey";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";

export const copyMod = createAsyncThunk<
  void,
  { mod: EmbeddedMod; targetVariationId: string }
>(
  "experienceBuilder/copyMod",
  ({ mod, targetVariationId }, { dispatch, getState }) => {
    const { getMods } = experienceBuilderSlice.selectors;
    const { updateMods } = experienceBuilderSlice.actions;

    const key = getCopyKey(mod);
    const mods = getMods(getState());

    const existing = mods.find(
      (m) => m.variationId === targetVariationId && getCopyKey(m) === key
    );
    const id = existing?.id ?? v4();
    const newMod = { ...mod, id, variationId: targetVariationId };
    dispatch(updateMods({ set: [newMod] }));

    // Track the mod save with duplicate source info
    const getVariationName = getVariationNameById(getState());
    const sourceGroupName = getVariationName(mod.variationId);
    void dispatch(
      trackModSaved({
        mod: newMod,
        duplicateSource: {
          groupId: mod.variationId,
          groupName: sourceGroupName,
        },
      })
    );
  }
);
